module.exports = __webpack_public_path__ + "static/media/layer-color.3caf6f67.svg";